export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
            关于51吃瓜网址
          </h2>
          <div className="prose prose-sm md:prose-base max-w-none">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              51吃瓜网址成立于2023年，是国内领先的娱乐八卦与实时热点资讯聚合平台。我们以"让吃瓜更专业、更及时、更有趣"为使命，致力于为广大瓜友提供最全面、最快速的51今日吃瓜与51吃瓜最新内容服务。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台覆盖51吃瓜网今日吃瓜专题、51吃瓜大赛评选、实时快讯追踪、热门话题讨论等核心板块，日均更新资讯超过1500条，累计服务用户超过五百万。我们拥有一支专业的编辑团队和遍布全网的信息采集网络，确保每一条资讯都经过严格核实，让读者可以放心吃瓜。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              从娱乐圈最新动态到社会热点追踪，从明星八卦到网红圈层，51吃瓜网址以专业视角为你呈现最有价值的吃瓜内容。你的每一次点击、每一条评论，都是我们不断进步的动力。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}